import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'td-wb-modal-panel',
  template: '<ng-content />',
  styleUrls: ['modal-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalPanelComponent {
  /* eslint-disable lines-between-class-members */
  @Input()
  set top(value: boolean) {
    this._top = value;
  }
  @HostBinding('class.td-wb-modal-panel--top')
  get topPadding(): boolean {
    return this._top;
  }

  @Input()
  set bottom(value: boolean) {
    this._bottom = value;
  }
  @HostBinding('class.td-wb-modal-panel--bottom')
  get bottomPadding(): boolean {
    return this._bottom;
  }

  @Input()
  set left(value: boolean) {
    this._left = value;
  }
  @HostBinding('class.td-wb-modal-panel--left')
  get leftPadding(): boolean {
    return this._left;
  }

  @Input()
  set right(value: boolean) {
    this._right = value;
  }
  @HostBinding('class.td-wb-modal-panel--right')
  get rightPadding(): boolean {
    return this._right;
  }
  /* eslint-enable lines-between-class-members */

  private _top: boolean = false;
  private _bottom: boolean = false;
  private _left: boolean = true;
  private _right: boolean = true;
}
